import { render, staticRenderFns } from "./QWistiaPlayer.vue?vue&type=template&id=46b447ac&"
import script from "./QWistiaPlayer.vue?vue&type=script&lang=js&"
export * from "./QWistiaPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports